<template>
  <div class="cases-listings">
    <base-header class="pb-6">
      <b-row align-v="center" class="py-3">
        <b-col cols="6">
          <p class="text-muted">My Account</p>
          <h2 class="listing-title d-inline-block mb-0">Credit Balance</h2>
        </b-col>
        <b-col
          cols="6"
          class="text-right"
          v-if="auth_user.subscription.scrb_is_my_own || checkAccess(['allow_transfer_corp_credit'])"
        >
          <span
            v-if="auth_user.subscription.scrb_is_my_own || checkRoleType(['admin'])"
            class="align-middle mr-2"
          >
            Need more reports? <a href="javascript:void(0)" @click="showReloadModal">Reload Here.</a>
          </span>
          <b-button variant="primary" class="btn-header" @click="$refs.transfer_drawer.showDrawer()">
            Transfer Credit
          </b-button>
        </b-col>
      </b-row>

      <b-row class="d-flex justify-content-end mb-3">
        <b-col cols="auto" md="auto" class="float-left flex-grow-1 text-left">
          <span
            class="badge bg-fintos text-dark font-weight-600"
            v-if="!auth_user.subscription.scrb_is_my_own"
          >
            You are currently using {{ auth_user.subscription.privileges.scpk_original_name }} subscription
          </span>
          <span
            class="badge bg-info text-dark font-weight-600"
            v-else
          >
            You are currently using your own {{ auth_user.subscription.privileges.scpk_original_name }} subscription
          </span>
        </b-col>
        <!-- <b-col cols="auto" md="auto" class="float-right text-right">
          <p>Total Available Requests</p>
          <h3 class="text-primary font-weight-600">{{ auth_user.subscription.scrb_credit_report }} reports</h3>
        </b-col> -->
        <b-col cols="auto" md="auto" class="float-right text-right">
          <p>Total Balance Points</p>
          <h3 class="text-primary font-weight-600">
            {{ auth_user.subscription.scrb_credit_points | moneyFormatter }}
          </h3>
        </b-col>
        <!-- <b-col cols="auto" md="auto" class="float-right text-right">
          <p>Total Balance Free Requests</p>
          <h3 class="text-primary font-weight-600">{{ auth_user.subscription.scrb_free_report }} reports</h3>
        </b-col> -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body class="px-3 pb-3">
        <el-tabs v-model="current_tab">
          <el-tab-pane label="Paid Report History" name="used-history">
            <span slot="label">
              <b-icon icon="wallet" class="mr-1"></b-icon>
              Paid Reports
            </span>
            <BaseTableReportHistoryListing
              :listBaseTableReportHistory="creditBalanceHistoryList.filter(item => item.cbh_credit_type != 'FREE_REPORT')"
              :loading="is_loading_page"
              @filter_submit="filterSubmit($event)"
            />
          </el-tab-pane>

          <!-- <el-tab-pane label="Credit History" name="topup-history">
            <span slot="label">
              <b-icon icon="wallet" class="mr-1"></b-icon>
              Free Requests
            </span>
            <BaseTableReportHistoryListing
              :listBaseTableReportHistory="creditBalanceHistoryList.filter(item => item.cbh_credit_type == 'FREE_REPORT')"
              :loading="is_loading_page"
              @filter_submit="filterSubmit($event)"
            />
          </el-tab-pane> -->
        </el-tabs>
      </b-card>
    </b-container>

    <LoadingPage :is_loading="is_loading_page" />
    <TransferDrawer ref="transfer_drawer" @close="getHistory()" />
    <ReloadFintscoreCreditModal ref="reloadFintscoreCreditModalRef" />
  </div>
</template>

<script>
import BaseTableReportHistoryListing from '@/views/CreditReports/CreditBalance/Tables/BaseTableReportHistory/BaseTableReportHistoryListing'
import TransferDrawer from '@/views/CreditReports/CreditBalance/Drawers/TransferDrawer'
import LoadingPage from '@/components/LoadingPage'
import ReloadFintscoreCreditModal from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerFintscoreReport/ReloadFintscoreCreditModal.vue'
import { Tabs, TabPane } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useBillingStore } from '@/stores/billingStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import caseEventBus from '@/assets/js/EventBus/caseEventBus.js'
import { notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'

export default {
  components: {
    LoadingPage,
    TransferDrawer,
    BaseTableReportHistoryListing,
    ReloadFintscoreCreditModal,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  mixins: [notifyFunctionMixin, helperFunctionMixin],

  data() {
    return {
      is_loading_page: false,
      current_tab: 'used-history',
      search: []
    }
  },

  computed: {
    ...mapState(useAuthStore, ['auth_user']),
    ...mapState(useBillingStore, ['creditBalanceHistoryList'])
  },

  async created() {
    await this.fetchData()
  },

  mounted() {
    caseEventBus.$on('refresh-cases', this.fetchData)
  },

  beforeUnmount() {
    caseEventBus.$off('refresh-cases', this.fetchData)
  },

  methods: {
    ...mapActions(useBillingStore, ['getCreditBalanceHistoryList']),
    ...mapActions(useAccessControlStore, ['getUsers']),

    async fetchData() {
      try {
        this.is_loading_page = true
        await this.getHistory()
        await this.getUsers(this.auth_user.account_info.corporate_id)
      } catch (e) {
        this.errorFunction(e)
      } finally {
        this.is_loading_page = false
      }
    },

    async getHistory() {
      let urlSearchParams = new URLSearchParams()
      urlSearchParams = this.getSearchParams(urlSearchParams)
      await this.getCreditBalanceHistoryList(urlSearchParams)
    },

    filterSubmit(event) {
      this.search = event
      this.fetchData()
    },

    getSearchParams(urlSearchParams) {
      if (this.isEmpty(this.search)) return urlSearchParams
      for (const key in this.search) {
        const value = this.search[key]
        if (!value) continue
        if (typeof value === 'object' && !Array.isArray(value)) {
          for (const subKey in value) {
            urlSearchParams.append(`search[${key}][${subKey}]`, value[subKey])
          }
        } else {
          urlSearchParams.append(`search[${key}]`, value)
        }
      }
      return urlSearchParams
    },

    showReloadModal() {
      this.$refs.reloadFintscoreCreditModalRef.toggleModal()
    }
  }
}
</script>
